import { DictionaryItem, Entity, FileModel, ImageModel } from '@hglobal/common';

import { Reaction } from '.';

export enum ArticleType {
  News = 'news',
  Faq = 'faq',
  Blog = 'blog',
}

export enum ImageViewModeType {
  Flip = 'flip',
  Gallery = 'gallery',
}

export type RubricTag = DictionaryItem;

export interface News extends Entity {
  title: string;
}

export interface NewsShop extends News {
  slug?: string;
  category?: NewsCategory;
  subcategory?: NewsSubcategory;
  minutesToRead?: string;
  previewImage: ImageModel;
  image: ImageModel;
  imageViewMode?: ImageViewModeType;
  articleImages: ImageModel[];
  previewText: string;
  fileButtons: ArticleFileButton[];
  article: string;
  publishedAt: string;
  read: boolean;
  saved: boolean;
  articleType: ArticleType;
  mainImage?: ImageModel; // FE field only
  articleImageUrls?: string[]; // FE field only
}

export interface ArticleFileButton {
  buttonName: string;
  file: FileModel;
  isFlipped: boolean;
  isPostedToSlack: boolean;
  previewImageUrl?: string;
}

export interface Article extends NewsShop {
  articleType: ArticleType;
  videoUrl?: string;
  linkName?: string;
  linkUrl?: string;
  reactions: Reaction[];
  commentsCount: number;
}

export interface ArticleForLink extends News {
  slug?: string;
  category?: NewsCategory;
  subcategory?: NewsSubcategory;
}

export interface NewsAdmin extends News {
  tag: RubricTag;
  publishedAt: string;
  visible: boolean;
}

export interface NewsForm extends News {
  articleType: ArticleType;
  previewImage: ImageModel;
  previewGifForSlack: ImageModel;
  image: ImageModel;
  categoryId: number;
  subcategoryId: number;
  minutesToRead: string;
  article: string;
  groupIds: number[];
  slackChannelIds: number[];
  visible: boolean;
  videoUrl?: string;
  fileButtons?: ArticleFileButton[];
  articleImages?: ImageModel[];
  imageViewMode?: ImageViewModeType;
  linkName?: string;
  linkUrl?: string;
  category?: NewsCategory;
  subcategory?: NewsSubcategory;
}

export interface GlobalSearchArticle extends News {
  category: NewsCategory;
  imageUrl: string;
  publishedAt: string;
}

export interface NewsCategory {
  id: number;
  slug?: string;
  name: string;
  iconName: string;
  visible: boolean;
  isDeletable: boolean;
}

export interface CategoryFormDialogData {
  category: NewsCategory;
}

export interface SubcategoryFormDialogData {
  subcategory: NewsSubcategory;
}

export interface NewsSubcategory {
  id: number;
  slug?: string;
  name: string;
  visible: boolean;
  isDeletable: boolean;
}

export enum NewsPagesEnum {
  NEWS_LIST = 'news-list',
  CATEGORIES = 'categories',
  SUBCATEGORIES = 'subcategories',
}
